export default __webpack_public_path__ + "static/media/profile.3bf95368.png";